export default "__VITE_ASSET__06933128__"